var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormControl, FormGroup } from "@angular/forms";
import { FormControlValidators } from "./validators/validator";
import { Subject } from "rxjs";
var BaseFormGroup = /** @class */ (function (_super) {
    __extends(BaseFormGroup, _super);
    function BaseFormGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.$beforeSubmit = new Subject();
        _this.sendFormError = null;
        return _this;
    }
    BaseFormGroup.prototype.setData = function (data) {
        var me = this;
        for (var _i = 0, _a = Object.getOwnPropertyNames(data); _i < _a.length; _i++) {
            var key = _a[_i];
            var control = me.get(key);
            if (control) {
                control.setValue(data[key]);
            }
        }
    };
    BaseFormGroup.prototype.getData = function () {
        return this.value;
    };
    return BaseFormGroup;
}(FormGroup));
export { BaseFormGroup };
var SupportModalForm = /** @class */ (function (_super) {
    __extends(SupportModalForm, _super);
    function SupportModalForm(controls, validatorOrOpts, asyncValidator) {
        var _this = _super.call(this, controls, validatorOrOpts, asyncValidator) || this;
        _this.addControl('comment', new FormControl('', [
            FormControlValidators.required(),
            FormControlValidators.minLength(10),
        ]));
        return _this;
    }
    return SupportModalForm;
}(BaseFormGroup));
export { SupportModalForm };
